import { render, staticRenderFns } from "./customdialog.vue?vue&type=template&id=58950e60&scoped=true&"
import script from "./customdialog.vue?vue&type=script&lang=js&"
export * from "./customdialog.vue?vue&type=script&lang=js&"
import style0 from "./customdialog.vue?vue&type=style&index=0&id=58950e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58950e60",
  null
  
)

export default component.exports